var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 228",
    clipPath: "url(#clip0_6_440)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7552 1.48907L26.4665 1.48901V4.20285L19.7552 4.20291C18.0622 4.20291 16.4905 5.08167 15.6038 6.52399L12.9199 10.89C12.7244 11.208 12.5076 11.5084 12.2718 11.7898L19.7413 11.7898C19.7459 11.7898 19.7505 11.7898 19.7551 11.7898H26.4116V14.5036H19.7551C19.7514 14.5036 19.7477 14.5036 19.7439 14.5037C18.0551 14.5075 16.4884 15.3856 15.6037 16.8247L12.9198 21.1907C11.5394 23.4362 9.09238 24.8044 6.45647 24.8044H9.15527e-05L9.16714e-05 22.0905H6.45647C8.14951 22.0905 9.72122 21.2118 10.6079 19.7695L13.2918 15.4035C13.4873 15.0855 13.7041 14.7851 13.9399 14.5037L0.000629908 14.5037V14.5036H0.000187787L0.000187905 11.7898H6.4566C8.14965 11.7898 9.72136 10.9111 10.608 9.46876L13.2919 5.10276C14.6723 2.85721 17.1193 1.48907 19.7552 1.48907Z",
    fill: "url(#paint0_linear_6_440)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_440",
    x1: 3.31103,
    y1: 13.1467,
    x2: 23.6442,
    y2: 13.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064254"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3594,
    height: 26.8117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/NewLogo.1cdb982e844560d7ddad7728b0a9a7b2.svg";
export { ForwardRef as ReactComponent };